import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Popup, Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class HeaderFilter extends Component {
  constructor(props) {
    super(props);
    this.clearFilter = this.clearFilter.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  handleFilterChange(event, data) {
    this.props.changeSuggestedOrderFilter(data.name, data.value.toUpperCase());
  }

  clearFilter() {
    const {name} = this.props;

    this.props.changeSuggestedOrderFilter(name, '');
  }

  renderIcon() {
    const {value} = this.props;

    if (!value) {
      return null;
    }

    return (
      <a>
        <i class="material-icons" onClick={this.clearFilter}>
          cancel
        </i>
      </a>
    );
  }

  render() {
    const {label, name, value, maxLength, size} = this.props;
    const style = !value ? '' : ' filtered';

    return (
      <Table.HeaderCell className={style}>
        <Popup
          on='click'
          position='top center'
          trigger={<span>
            {label}
            {this.renderIcon()}
          </span>}
        >
          <Input
            className={`tde-table-filter ${size}`}
            size='mini'
            maxLength={maxLength}
            name={name}
            value={value}
            onChange={this.handleFilterChange}
          />
        </Popup>
      </Table.HeaderCell>
    );
  }
}

HeaderFilter.defaultProps = {
  'maxLength': '2',
  'size': 'small',
};

const mapStateToProps = (state, ownProps) => ({
  'value': state.providerStockOrders[ownProps.name],
});

const {changeSuggestedOrderFilter} = Actions;

export default connect(mapStateToProps, {
  changeSuggestedOrderFilter,
})(HeaderFilter);
